var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0V1.5H0V4.5H1.5V24C1.5 24.7956 1.81607 25.5587 2.37868 26.1213C2.94129 26.6839 3.70435 27 4.5 27H19.5C20.2956 27 21.0587 26.6839 21.6213 26.1213C22.1839 25.5587 22.5 24.7956 22.5 24V4.5H24V1.5H16.5V0H7.5ZM7.5 7.5H10.5V21H7.5V7.5ZM13.5 7.5H16.5V21H13.5V7.5Z",
    fill: "#918F8F",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.b37cfb92769fce75689111bf2a106be9.svg";
export { ForwardRef as ReactComponent };